export class PubChannel {
    public __classname__: string = 'PubChannel';

	public Id : string | null = null;
	public Name: string | null = null;

    constructor(
        Id : string | null = null, 
        Name: string | null = null
    ) {
        this.Id = Id;
        this.Name = Name;
    }
}